import { createI18n } from "vue-i18n";
import store from "./store/store";
function loadLocaleMessages() {
  const locales = require.context(
    "./Locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}
const userLang = store.state?.auth?.user?.user?.user_language?.toLowerCase();
const defaultLang = userLang
  ? userLang === "en" || userLang === "en-us"
    ? "en"
    : userLang
  : "en";

const is_open_admin = sessionStorage.getItem("is_open_admin");
export default createI18n({
  locale: is_open_admin ? defaultLang : "en",
  fallbackLocale: is_open_admin ? defaultLang : "en",
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
  globalInjection: true,
  legacy: false,
});
